import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import StatusChip from "../StatusChip";
import { errMsg } from "../../lib/portfolio";

const STATE_CHIP = { comment: ["pending_approval", "Comment"], approve: ["approved", "Approved"], request_changes: ["rejected", "Changes requested"] };

export function CommentsPanel({ projectId, reloadKey }) {
  const [items, setItems] = useState([]);
  const [body, setBody] = useState("");
  const load = useCallback(() => {
    api.get(`/admin/portfolio/projects/${projectId}/comments`).then((r) => setItems(r.data.items)).catch(() => {});
  }, [projectId]);
  useEffect(() => { load(); }, [load, reloadKey]);
  const post = async (e) => {
    e.preventDefault();
    try { await api.post(`/admin/portfolio/projects/${projectId}/comments`, { body }); setBody(""); load(); }
    catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <div className="space-y-3" data-testid="portfolio-comments-panel">
      {items.length === 0 && <p className="text-sm font-nav text-erf-dark/70">No comments yet.</p>}
      <ul className="space-y-2">
        {items.map((c) => {
          const [st, label] = STATE_CHIP[c.state] || STATE_CHIP.comment;
          return (
            <li key={c.id} className="rounded-md border border-erf-borderCream bg-white p-3" data-testid={`portfolio-comment-${c.id}`}>
              <div className="flex flex-wrap items-center gap-2 mb-1">
                <StatusChip status={st} label={label} />
                <span className="text-xs font-mono text-erf-dark/70 ds-text-safe">{c.author_email} · {new Date(c.created_at).toLocaleString()}</span>
              </div>
              <p className="text-sm font-nav text-erf-dark whitespace-pre-wrap">{c.body}</p>
            </li>
          );
        })}
      </ul>
      <form onSubmit={post} className="space-y-2">
        <Textarea value={body} onChange={(e) => setBody(e.target.value)} maxLength={4000} rows={3} required
          aria-label="Write a comment" placeholder="Write a comment" className="bg-white text-erf-dark" data-testid="portfolio-comment-input" />
        <Button type="submit" variant="outline" disabled={!body.trim()} className="border-erf-borderCream text-erf-dark"
          data-testid="portfolio-comment-submit">Post comment</Button>
      </form>
    </div>
  );
}
